// src/v3/transactions/attached-invoice.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var AttachedInvoiceIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "AttachedInvoiceIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currenColor",
    fillRule: "evenodd",
    d: "m19.738 7.49-4.929-5.203A.901.901 0 0 0 14.15 2H5.506C4.67 2 4 2.718 4 3.59v16.95c0 .493.243.955.651 1.221.438.288 1.001.329 1.536.052l2.352-1.498 2.77 1.508c.215.123.458.174.7.174.244 0 .477-.061.7-.174l2.83-1.59 2.322 1.57c.467.246 1.04.215 1.478-.073.418-.266.661-.728.661-1.23V8.165c0-.256-.097-.502-.262-.687v.01Zm-4.822-2.904 2.664 2.81h-2.664v-2.81Zm1.332 14.323a1.462 1.462 0 0 0-1.38.01l-2.897 1.54-2.76-1.509c-.419-.226-.924-.236-1.43.02l-2.323 1.57.049-17.001h7.951v4.556c0 .472.36.851.807.851h4.277v8.496l.039 3.047-2.323-1.57-.01-.01Zm-.482-6.879A.727.727 0 0 0 16 11.5a.727.727 0 0 0-.234-.53.828.828 0 0 0-.566-.22H8.8a.828.828 0 0 0-.566.22.727.727 0 0 0-.234.53c0 .199.084.39.234.53.15.141.354.22.566.22h6.4a.828.828 0 0 0 .566-.22Zm0 3A.727.727 0 0 0 16 14.5a.727.727 0 0 0-.234-.53.828.828 0 0 0-.566-.22H8.8a.828.828 0 0 0-.566.22.727.727 0 0 0-.234.53c0 .199.084.39.234.53.15.141.354.22.566.22h6.4a.828.828 0 0 0 .566-.22Z",
    clipRule: "evenodd"
  }
) });

export {
  AttachedInvoiceIcon
};
